var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreezeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.17 84.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".breezeLogo{fill:#f77721;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "breeze_logo_icon_orange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "breezeLogo",
    d: "M25.45,0V37.5a37.5,37.5,0,0,1,11.89-.31V11.89H65.83v60.3H37.34V55.36L25.45,49.65V84.07H77.71V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "breezeLogo",
    d: "M54.47,36.84a36.7,36.7,0,0,0,5.41,2.46V51.72a47.1,47.1,0,0,1-11.19-4.49c-21.67-12-39.82,4.3-40.58,5L0,43.55C8.57,35.51,31,23.77,54.47,36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "breezeLogo",
    d: "M103.17,40.53a49.93,49.93,0,0,1-31.4,12.54V41.25c13.29-.38,22.74-8.92,23.29-9.41Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreezeIcon);
export default __webpack_public_path__ + "static/media/BreezeIcon.4c8949b9dbbafa58572536ba810f2441.svg";
export { ForwardRef as ReactComponent };